import ClipConfigurationSportLevelModel from '@modules/clipConfiguration/forms/ClipConfigurationSportLevelModel';

export default function ClipConfigurationSportLevelEditModel() {
    const clipConfigurationSportLevelEditModel = ClipConfigurationSportLevelModel();

    clipConfigurationSportLevelEditModel.entityLabel = 'clip configuration';

    return clipConfigurationSportLevelEditModel;
}
